// import "./update.scss";
// import Select from "react-select";
// import Sidebar from "../../components/sidebar/Sidebar";
// import Navbar from "../../components/navbar/Navbar";
// import DriveFolderUploadOutlinedIcon from "@mui/icons-material/DriveFolderUploadOutlined";
// import { useState, useEffect } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import { groupInputs } from "../../formSource";
// import { serverUrl } from "../../temp";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// const statusOptions = [
//   { value: 1, label: "Active" },
//   { value: 0, label: "Inactive" },
// ];
// const NameOptions = [
//   { value: "Biology", label: "Biology" },
//   { value: "Computer", label: "Computer" },
//   { value: "PreEngineering", label: "PreEngineering" },
//   { value: "PreMedical", label: "PreMedical" },
// ];

// const GroupUpdate = ({ title }) => {
//   // Extracting groupId using regular expressions
//   const location = useLocation();
//   const groupId = location.pathname.match(/\/update-group\/(\d+)/)?.[1];
//   const center_id = localStorage.getItem("center_id");
//   // Initializing state
//   // const [file, setFile] = useState(null);
//   const [inputValues, setInputValues] = useState("");
//   const [selectedStatus, setSelectedStatus] = useState(null);
//   const [selectedName, setSelectedName] = useState(null);
//   const [selectedSubject, setSelectedSubject] = useState([]);
//   const [subjectoptions, setSubjectoptions] = useState([]);
//   const [selectedClass, setSelectedClass] = useState([]);
//   const [classoptions, setClassoptions] = useState([]);
//   const [selectedBatch, setSelectedBatch] = useState([]);
//   const [batchoptions, setBatchoptions] = useState([]);
//   let [token] = useState(localStorage.getItem("token"));

//   const redirectToLogin = () => {
//     alert("Plaese Login first then you can access this page...");
//     window.location.href = "/"; // Replace "/login" with the actual login page path
//   };

//   const navigate = useNavigate();

//   useEffect(() => {
//     const fetchGroup = async () => {
//       try {
//         const response = await fetch(`${serverUrl}/group/${groupId}`, {
//           method: "GET",
//         });
//         if (!response.ok) {
//           throw new Error("Failed to fetch quiz");
//         }
//         const data = await response.json();
//         console.log("abbas", data);
//         const snames = data.data.subject_names.split(",");
//         const sid = data.data.subject_id.split(",");
//         // console.log("abbas1",abbas);
//         const namelist = [];
//         for (let i = 0; i < snames.length; i++) {
//           const name = snames[i];
//           console.log(name);
//           const id = sid[i]; // Access the "name" property
//           namelist.push({ value: id, label: name });
//         }
//         const cnames = data.data.class_names;
//         const cid = data.data.class_id;
//         // console.log("abbas1",abbas);
//         const namelist1 = [];
//         namelist1.push({ value: cid, label: cnames });

//         const bnames = data.data.batch_names;
//         const bid = data.data.batch_id;
//         // console.log("abbas1",abbas);
//         const namelist2 = [];
//         namelist2.push({ value: bid, label: bnames });

//         const status = data.data.status;
//         if (status == 1) {
//           setSelectedStatus({ value: status, label: "Active" });
//         } else {
//           setSelectedStatus({ value: status, label: "Inactive" });
//         }
//         const name = data.data.name;
//         if (name == "Biology") {
//           setSelectedName({ value: name, label: "Biology" });
//         } else if (name == "Computer") {
//           setSelectedName({ value: name, label: "Computer" });
//         } else if (name == "PreEngineering") {
//           setSelectedName({ value: name, label: "PreEngineering" });
//         } else {
//           setSelectedName({ value: name, label: "PreMedical" });
//         }
//         setSelectedSubject(namelist);
//         setSelectedClass(namelist1);
//         setSelectedBatch(namelist2);
//         setInputValues(data.data);
//         // setFile(data.data.logo);
//         localStorage.setItem("quizData", JSON.stringify(data));
//       } catch (error) {
//         console.error(error);
//       }
//     };

//     if (groupId) {
//       fetchGroup();
//     }
//   }, [groupId]);
//   // console.log("quiz in a state:", data);

//   const handleStatusSelectChange = (selectedOption) => {
//     setSelectedStatus(selectedOption);
//     setInputValues({
//       ...inputValues,
//       status: selectedOption.value,
//     });
//   };

//   const handleNameSelectChange = (selectedOption) => {
//     setSelectedName(selectedOption);
//     setInputValues({
//       ...inputValues,
//       name: selectedOption.value,
//     });
//   };

//   const handleInputChange = (e) => {
//     setInputValues({
//       ...inputValues,
//       [e.target.name]: e.target.value,
//     });
//   };

//   const handleSubjectSelectChange = (selectedOptions) => {
//     setSelectedSubject(selectedOptions);

//     // Update the subject_id in inputValues
//     const roleIds = selectedOptions.map((option) => option.value);
//     setInputValues({
//       ...inputValues,
//       subject_id: roleIds,
//     });

//     // Recalculate subject options (add back unselected options)
//     subject_names(selectedOptions);
//   };

//   useEffect(() => {
//     subject_names();
//   }, []); // Empty dependency array means it runs once when the component mounts

//   const subject_names = async (selectedOptions = selectedSubject) => {
//     try {
//       const response = await fetch(`${serverUrl}/subject_ids/${center_id}`);
//       if (!response.ok) throw new Error("Failed to fetch data from the API");

//       const data = await response.json();

//       const allSubjects = data.data.map((item) => ({
//         value: String(item.id),
//         label: item.name,
//       }));

//       const selectedIds = selectedOptions.map((subj) => String(subj.value));

//       const filteredSubjects = allSubjects.filter(
//         (subject) => !selectedIds.includes(subject.value)
//       );

//       setSubjectoptions(filteredSubjects);
//     } catch (error) {
//       console.error("Error fetching subjects:", error);
//     }
//   };

//   const handleBatchSelectChange = (selectedOption) => {
//     setSelectedBatch(selectedOption);
//     setInputValues({
//       ...inputValues,
//       batch_id: selectedOption.value,
//     });
//   };
//   useEffect(() => {
//     batch_name();
//   }, []); // Empty dependency array means it runs once when the component mounts

//   const batch_name = async () => {
//     try {
//       const response = await fetch(`${serverUrl}/batch_ids/${center_id}`);
//       if (!response.ok) {
//         throw new Error("Failed to fetch data from the API");
//       }
//       const data = await response.json();
//       console.log(data.data.length);
//       const namelist = [];
//       for (let i = 0; i < data.data.length; i++) {
//         const name = data.data[i].name;
//         console.log(name);
//         const id = data.data[i].id; // Access the "name" property
//         namelist.push({ value: id, label: name });
//       }
//       console.log(namelist);
//       setBatchoptions(namelist);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };

//   const handleClassSelectChange = (selectedOption) => {
//     setSelectedClass(selectedOption);
//     setInputValues({
//       ...inputValues,
//       class_id: selectedOption.value,
//     });
//   };
//   useEffect(() => {
//     class_name();
//   }, []); // Empty dependency array means it runs once when the component mounts

//   const class_name = async () => {
//     try {
//       const response = await fetch(`${serverUrl}/class_ids/${center_id}`);
//       if (!response.ok) {
//         throw new Error("Failed to fetch data from the API");
//       }
//       const data = await response.json();
//       console.log(data.data.length);
//       const namelist = [];
//       for (let i = 0; i < data.data.length; i++) {
//         const name = data.data[i].name;
//         console.log(name);
//         const id = data.data[i].id; // Access the "name" property
//         namelist.push({ value: id, label: name });
//       }
//       console.log(namelist);
//       setClassoptions(namelist);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };

//   const handleUpdate = async (e) => {
//     e.preventDefault();

//     const formData = new FormData();
//     formData.append("id", groupId);
//     const UserValues = selectedSubject.map((option) => option.value);
//     formData.append("center_id", localStorage.getItem("center_id"));
//     formData.append("subject_id", UserValues);
//     formData.append("class_id", inputValues.class_id);
//     formData.append("batch_id", inputValues.batch_id);
//     formData.append("name", inputValues.name);
//     formData.append("status", parseInt(inputValues.status));
//     console.log(formData);

//     // Send formData to the server using an HTTP request to update
//     fetch(`${serverUrl}/upd_group/${groupId}`, {
//       method: "PUT",
//       body: formData, // Pass the object as the body
//     })
//       .then((response) => {
//         return response.json();
//       })
//       .then((data) => {
//         if (data.code >= 400) {
//           if (typeof data.message === "object") {
//             Object.entries(data.message).forEach(([field, errors]) => {
//               errors.forEach((errMsg) => {
//                 toast.error(`${field}: ${errMsg}`);
//               });
//             });
//           } else {
//             toast.error(data.message || "Something went wrong.");
//           }

//           // setFilteredOptions(options); // Reset available roles

//           // Force the component to rerender with the empty state
//           setTimeout(() => {}, 500); // Adding timeout to allow state change
//         } else {
//           toast.success("Group updated successfully!");
//           setTimeout(() => {
//             navigate("/group");
//           }, 1000);
//         }
//       })
//       .catch((error) => {
//         console.log(error);
//       });
//   };

//   return (
//     <>
//       {!token && redirectToLogin()}
//       {token && (
//         <div className="update">
//           <Sidebar />
//           <div className="updateContainer">
//             <Navbar />
//             <div className="top">
//               <h1>{title}</h1>
//             </div>
//             <div className="bottom">
//               {/* <div className="left">
//                                 <img
//                                     src={
//                                         // file
//                                     }
//                                     alt=""
//                                     className="itemImg"
//                                 />
//                             </div> */}
//               <div className="right">
//                 <form onSubmit={handleUpdate}>
//                   {groupInputs.map((input) => (
//                     <div className="formInput" key={input.id}>
//                       <label>{input.label}</label>
//                       {input.fieldName === "subject_id" ? (
//                         <Select
//                           options={subjectoptions}
//                           name={input.fieldName}
//                           isMulti // Enable multiple selection
//                           value={selectedSubject}
//                           onChange={handleSubjectSelectChange}
//                           required
//                         />
//                       ) : input.fieldName === "status" ? (
//                         <Select
//                           options={statusOptions}
//                           name={input.fieldName}
//                           value={selectedStatus}
//                           onChange={handleStatusSelectChange}
//                           required
//                         />
//                       ) : input.fieldName === "name" ? (
//                         <Select
//                           options={NameOptions}
//                           name={input.fieldName}
//                           value={selectedName}
//                           onChange={handleNameSelectChange}
//                           required
//                         />
//                       ) : input.fieldName === "batch_id" ? (
//                         <Select
//                           options={batchoptions}
//                           name={input.fieldName}
//                           value={selectedBatch}
//                           onChange={handleBatchSelectChange}
//                           required
//                         />
//                       ) : input.fieldName === "class_id" ? (
//                         <Select
//                           options={classoptions}
//                           name={input.fieldName}
//                           value={selectedClass}
//                           onChange={handleClassSelectChange}
//                           required
//                         />
//                       ) : (
//                         <input
//                           type={input.type}
//                           placeholder={input.placeholder}
//                           name={input.fieldName}
//                           value={inputValues[input.fieldName] || ""}
//                           onChange={handleInputChange}
//                           required
//                           // inputMode={input.fieldName === 'no_of_quiz' ? 'numeric' : undefined}
//                         />
//                       )}
//                     </div>
//                   ))}
//                   <div style={{ clear: "both" }} className="formUpdate">
//                     <button
//                       style={{ float: "right" }}
//                       // onClick={() => navigate(`/class`)}
//                     >
//                       Update
//                     </button>
//                   </div>
//                   <div>
//                     <button
//                       type="button"
//                       style={{ float: "right" }}
//                       onClick={() => navigate(`/group`)}
//                     >
//                       Cancel
//                     </button>
//                   </div>
//                 </form>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//       <ToastContainer position="top-right" autoClose={3000} />
//     </>
//   );
// };

// export default GroupUpdate;
import React, { useState, useEffect } from "react";
import Select from "react-select";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import { groupInputs } from "../../formSource";
import { useLocation, useNavigate } from "react-router-dom";
import { serverUrl } from "../../temp";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import "./update.scss";

const theme = createTheme({
  palette: {
    primary: {
      main: "#7451f8",
    },
    secondary: {
      main: "#6c757d",
    },
  },
});

const statusOptions = [
  { value: 1, label: "Active" },
  { value: 0, label: "Inactive" },
];

const NameOptions = [
  { value: "Biology", label: "Biology" },
  { value: "Computer", label: "Computer" },
  { value: "PreEngineering", label: "PreEngineering" },
  { value: "PreMedical", label: "PreMedical" },
];

const GroupUpdate = ({ title }) => {
  const location = useLocation();
  const groupId = location.pathname.match(/\/update-group\/(\d+)/)?.[1];
  const center_id = localStorage.getItem("center_id");
  const navigate = useNavigate();

  const [inputValues, setInputValues] = useState({});
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [selectedName, setSelectedName] = useState(null);
  const [selectedSubject, setSelectedSubject] = useState([]);
  const [subjectoptions, setSubjectoptions] = useState([]);
  const [selectedClass, setSelectedClass] = useState(null);
  const [classoptions, setClassoptions] = useState([]);
  const [selectedBatch, setSelectedBatch] = useState(null);
  const [batchoptions, setBatchoptions] = useState([]);
  let [token] = useState(localStorage.getItem("token"));

  const redirectToLogin = () => {
    alert("Please Login first, then you can access this page...");
    window.location.href = "/";
  };

  useEffect(() => {
    const fetchGroup = async () => {
      try {
        const response = await fetch(`${serverUrl}/group/${groupId}`, {
          method: "GET",
        });
        if (!response.ok) {
          throw new Error("Failed to fetch group data");
        }
        const data = await response.json();
        
        // Set subjects
        const subjectNames = data.data.subject_names.split(",");
        const subjectIds = data.data.subject_id.split(",");
        const subjects = subjectNames.map((name, i) => ({
          value: subjectIds[i],
          label: name
        }));
        
        // Set status
        setSelectedStatus(
          data.data.status === 1
            ? { value: 1, label: "Active" }
            : { value: 0, label: "Inactive" }
        );
        
        // Set name
        setSelectedName(
          NameOptions.find(opt => opt.value === data.data.name) || null
        );
        
        // Set class
        setSelectedClass({
          value: data.data.class_id,
          label: data.data.class_names
        });
        
        // Set batch
        setSelectedBatch({
          value: data.data.batch_id,
          label: data.data.batch_names
        });
        
        setSelectedSubject(subjects);
        setInputValues(data.data);
      } catch (error) {
        console.error(error);
        toast.error("Failed to fetch group data.");
      }
    };

    if (groupId) {
      fetchGroup();
    }
  }, [groupId]);

  useEffect(() => {
    subject_names();
    batch_name();
    class_name();
  }, []);

  const subject_names = async (selectedOptions = selectedSubject) => {
    try {
      const response = await fetch(`${serverUrl}/subject_ids/${center_id}`);
      if (!response.ok) throw new Error("Failed to fetch subjects");
      
      const data = await response.json();
      const allSubjects = data.data.map(item => ({
        value: String(item.id),
        label: item.name
      }));

      const selectedIds = selectedOptions.map(subj => String(subj.value));
      const filteredSubjects = allSubjects.filter(
        subject => !selectedIds.includes(subject.value)
      );

      setSubjectoptions(filteredSubjects);
    } catch (error) {
      console.error("Error fetching subjects:", error);
      toast.error("Failed to fetch subjects data.");
    }
  };

  const batch_name = async () => {
    try {
      const response = await fetch(`${serverUrl}/batch_ids/${center_id}`);
      if (!response.ok) throw new Error("Failed to fetch batches");
      
      const data = await response.json();
      const batches = data.data.map(item => ({
        value: item.id,
        label: item.name
      }));
      
      setBatchoptions(batches);
    } catch (error) {
      console.error("Error fetching batches:", error);
      toast.error("Failed to fetch batches data.");
    }
  };

  const class_name = async () => {
    try {
      const response = await fetch(`${serverUrl}/class_ids/${center_id}`);
      if (!response.ok) throw new Error("Failed to fetch classes");
      
      const data = await response.json();
      const classes = data.data.map(item => ({
        value: item.id,
        label: item.name
      }));
      
      setClassoptions(classes);
    } catch (error) {
      console.error("Error fetching classes:", error);
      toast.error("Failed to fetch classes data.");
    }
  };

  const handleStatusSelectChange = (selectedOption) => {
    setSelectedStatus(selectedOption);
    setInputValues({
      ...inputValues,
      status: selectedOption.value,
    });
  };

  const handleNameSelectChange = (selectedOption) => {
    setSelectedName(selectedOption);
    setInputValues({
      ...inputValues,
      name: selectedOption.value,
    });
  };

  const handleSubjectSelectChange = (selectedOptions) => {
    setSelectedSubject(selectedOptions);
    setInputValues({
      ...inputValues,
      subject_id: selectedOptions.map(option => option.value),
    });
    subject_names(selectedOptions);
  };

  const handleBatchSelectChange = (selectedOption) => {
    setSelectedBatch(selectedOption);
    setInputValues({
      ...inputValues,
      batch_id: selectedOption.value,
    });
  };

  const handleClassSelectChange = (selectedOption) => {
    setSelectedClass(selectedOption);
    setInputValues({
      ...inputValues,
      class_id: selectedOption.value,
    });
  };

  const handleInputChange = (e) => {
    setInputValues({
      ...inputValues,
      [e.target.name]: e.target.value,
    });
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    
    formData.append("id", groupId);
    formData.append("center_id", center_id);
    formData.append("subject_id", inputValues.subject_id);
    formData.append("class_id", inputValues.class_id);
    formData.append("batch_id", inputValues.batch_id);
    formData.append("name", inputValues.name);
    formData.append("status", parseInt(inputValues.status));

    try {
      const response = await fetch(`${serverUrl}/upd_group/${groupId}`, {
        method: "PUT",
        body: formData,
      });
      const data = await response.json();

      if (data.code >= 400) {
        if (typeof data.message === "object") {
          Object.entries(data.message).forEach(([field, errors]) => {
            errors.forEach((errMsg) => {
              toast.error(`${field}: ${errMsg}`);
            });
          });
        } else {
          toast.error(data.message || "Something went wrong.");
        }
      } else {
        toast.success("Group updated successfully!");
        setTimeout(() => {
          navigate("/group");
        }, 1000);
      }
    } catch (error) {
      console.error(error);
      toast.error("Network error. Please try again.");
    }
  };

  return (
    <ThemeProvider theme={theme}>
      {!token && redirectToLogin()}
      {token && (
        <div className="update">
          <Sidebar />
          <div className="updateContainer">
            <Navbar />
            <div className="contentWrapper">
              <Card className="formCard">
                <CardContent className="cardContent">
                  <Typography variant="h5" component="h2" gutterBottom className="formTitle">
                    {title}
                  </Typography>
                  <form onSubmit={handleUpdate} className="responsiveForm">
                    <Grid container spacing={2}>
                      {groupInputs.map((input) => (
                        <Grid item xs={12} sm={6} key={input.id} className="formGridItem">
                          <div className="formInput">
                            <label>{input.label}</label>
                            {input.fieldName === "subject_id" ? (
                              <Select
                                options={subjectoptions}
                                isMulti
                                value={selectedSubject}
                                onChange={handleSubjectSelectChange}
                                required
                                className="selectInput"
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    minHeight: '46px',
                                    borderColor: '#e2e8f0',
                                    '&:hover': {
                                      borderColor: '#cbd5e0'
                                    }
                                  }),
                                  valueContainer: (base) => ({
                                    ...base,
                                    padding: '2px 8px'
                                  }),
                                  input: (base) => ({
                                    ...base,
                                    margin: '0',
                                    padding: '0'
                                  }),
                                  indicatorsContainer: (base) => ({
                                    ...base,
                                    height: '44px'
                                  })
                                }}
                              />
                            ) : input.fieldName === "status" ? (
                              <Select
                                options={statusOptions}
                                value={selectedStatus}
                                onChange={handleStatusSelectChange}
                                required
                                className="selectInput"
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    minHeight: '46px',
                                    borderColor: '#e2e8f0',
                                    '&:hover': {
                                      borderColor: '#cbd5e0'
                                    }
                                  }),
                                  valueContainer: (base) => ({
                                    ...base,
                                    padding: '2px 8px'
                                  }),
                                  input: (base) => ({
                                    ...base,
                                    margin: '0',
                                    padding: '0'
                                  }),
                                  indicatorsContainer: (base) => ({
                                    ...base,
                                    height: '44px'
                                  })
                                }}
                              />
                            ) : input.fieldName === "name" ? (
                              <Select
                                options={NameOptions}
                                value={selectedName}
                                onChange={handleNameSelectChange}
                                required
                                className="selectInput"
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    minHeight: '46px',
                                    borderColor: '#e2e8f0',
                                    '&:hover': {
                                      borderColor: '#cbd5e0'
                                    }
                                  }),
                                  valueContainer: (base) => ({
                                    ...base,
                                    padding: '2px 8px'
                                  }),
                                  input: (base) => ({
                                    ...base,
                                    margin: '0',
                                    padding: '0'
                                  }),
                                  indicatorsContainer: (base) => ({
                                    ...base,
                                    height: '44px'
                                  })
                                }}
                              />
                            ) : input.fieldName === "batch_id" ? (
                              <Select
                                options={batchoptions}
                                value={selectedBatch}
                                onChange={handleBatchSelectChange}
                                required
                                className="selectInput"
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    minHeight: '46px',
                                    borderColor: '#e2e8f0',
                                    '&:hover': {
                                      borderColor: '#cbd5e0'
                                    }
                                  }),
                                  valueContainer: (base) => ({
                                    ...base,
                                    padding: '2px 8px'
                                  }),
                                  input: (base) => ({
                                    ...base,
                                    margin: '0',
                                    padding: '0'
                                  }),
                                  indicatorsContainer: (base) => ({
                                    ...base,
                                    height: '44px'
                                  })
                                }}
                              />
                            ) : input.fieldName === "class_id" ? (
                              <Select
                                options={classoptions}
                                value={selectedClass}
                                onChange={handleClassSelectChange}
                                required
                                className="selectInput"
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    minHeight: '46px',
                                    borderColor: '#e2e8f0',
                                    '&:hover': {
                                      borderColor: '#cbd5e0'
                                    }
                                  }),
                                  valueContainer: (base) => ({
                                    ...base,
                                    padding: '2px 8px'
                                  }),
                                  input: (base) => ({
                                    ...base,
                                    margin: '0',
                                    padding: '0'
                                  }),
                                  indicatorsContainer: (base) => ({
                                    ...base,
                                    height: '44px'
                                  })
                                }}
                              />
                            ) : (
                              <input
                                type={input.type}
                                placeholder={input.placeholder}
                                name={input.fieldName}
                                value={inputValues[input.fieldName] || ""}
                                onChange={handleInputChange}
                                required
                              />
                            )}
                          </div>
                        </Grid>
                      ))}
                    </Grid>
                    <Box sx={{ display: "flex", justifyContent: "center", gap: 3, mt: 4, pb: 2 }}>
                      <Button
                        variant="outlined"
                        color="secondary"
                        onClick={() => navigate("/group")}
                        sx={{ minWidth: '120px', height: '42px' }}
                      >
                        Cancel
                      </Button>
                      <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        sx={{ minWidth: '150px', height: '42px' }}
                      >
                        Update Group
                      </Button>
                    </Box>
                  </form>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      )}
      <ToastContainer position="top-right" autoClose={3000} />
    </ThemeProvider>
  );
};

export default GroupUpdate;